import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSeoData } from '@/lib/seo';
import { applyHead } from '@/lib/head';
import { getJsonLd, applyJsonLd } from '@/lib/schema';

export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    const seo = getSeoData(location.pathname);
    applyHead(seo);
    applyJsonLd(getJsonLd(seo));
  }, [location.pathname]);

  return null;
}